import Router from 'next/router';

const redirectUrl = (basePath: string) => async (finalPath: string) => {
  return await Router.push(`${basePath}${finalPath}`);
};

export const checkoutRedirectUrl = redirectUrl('/checkout');
export const homeRedirectUrl = redirectUrl('/');
export const redirectToPaymentProvider = redirectUrl('');
